// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ptXD","left":"InfoRow_left__2P5xn"};